import CancellableHelper from "@/requests/CancellableHelper";
import { IntegrationListItemResponse } from "@/models/api/administration/integration/integrationListItem";
import { IntegrationConfigurationListItem } from "@/models/api/administration/integration/integrationConfigurationListItem";
import GenericTableRequest from "@/models/api/GenericTableRequest";
import { axiosInstance } from "@/plugins/axios";

//#region Routes
export const URL_GET_INTEGRATION_LIST = "/Integration/GetIntegrationList";
export const URL_GET_INTEGRATION_CONFIGURATION_LIST = "/Integration/GetIntegrationConfigurationList";
export const URL_POST_TEST_INTEGRATION_CONNECTION = "/Integration/${IntegrationId}/TestConnection";
export const URL_POST_UPDATE_INTEGRATION_CONFIGURATION = "/Integration/UpdateIntegrationConfiguration";
export const URL_POST_ADD_NEW_INTEGRATION = "/Integration/AddNewIntegration";
export const URL_POST_DELETE_INTEGRATION = "/Integration/DeleteIntegration";
//#endregion

const _getIntegrationList = new CancellableHelper<IntegrationListItemResponse>(
  URL_GET_INTEGRATION_LIST,
  IntegrationListItemResponse
);
_getIntegrationList.jsonSerializer = true;
export const getIntegrationList = async (
  genericTableRequest: GenericTableRequest
): Promise<IntegrationListItemResponse> => {
  return await _getIntegrationList.get(genericTableRequest);
};

const _getIntegrationConfigurationList = new CancellableHelper<Array<IntegrationConfigurationListItem>>(
  URL_GET_INTEGRATION_CONFIGURATION_LIST,
  IntegrationConfigurationListItem
);
export const getIntegrationConfigurationList = async (
  integrationId: string
): Promise<Array<IntegrationConfigurationListItem>> => {
  return await _getIntegrationConfigurationList.get({
    IntegrationId: integrationId,
  });
};

export const postTestIntegrationConnection = async (integrationId: string): Promise<void> => {
  await axiosInstance.post(URL_POST_TEST_INTEGRATION_CONNECTION.replace("${IntegrationId}", integrationId));
};

const _postUpdateIntegrationConfiguration = new CancellableHelper<null>(
  URL_POST_UPDATE_INTEGRATION_CONFIGURATION,
  null,
  true
);
export const postUpdateIntegrationConfiguration = async (
  integrationId: string,
  settings: Array<IntegrationConfigurationListItem>
): Promise<null> => {
  return await _postUpdateIntegrationConfiguration.post({ IntegrationId: integrationId }, settings);
};

const _postAddNewIntegration = new CancellableHelper<null>(URL_POST_ADD_NEW_INTEGRATION, null, true);
export const postAddNewIntegration = async (
  name: string,
  providerKey: number,
  settings: Array<IntegrationConfigurationListItem>
): Promise<null> => {
  return await _postAddNewIntegration.post({ Name: name, ProviderKey: providerKey }, settings);
};

const _postDeleteIntegration = new CancellableHelper<null>(URL_POST_DELETE_INTEGRATION, null, true);
export const postDeleteIntegration = async (integrationId: string): Promise<null> => {
  return await _postDeleteIntegration.post({ IntegrationId: integrationId }, null);
};
